import { render } from "./PageLayout.vue?vue&type=template&id=08af2e82&scoped=true"
import script from "./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue?vue&type=script&lang=js"

import "./PageLayout.vue?vue&type=style&index=0&id=08af2e82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08af2e82"]])

export default __exports__